<template>
  <div class="">

    <div class="mb-3">
      <b-row class="text-center" style="margin-left: 4px; ">

        <b-col col lg="4" ref="listaAssociados" class="bg-light no-padding" >
          <div class="alturaMin"  style="height: 510px !important; overflow-y: auto !important">

            <div class="titulo"><span> {{ tituloAssociados }} {{ (!tituloCompleto)?' Associados':'' }} </span></div>

            <div
              v-for="(item, index) in dadoAssociado"
              :key="index"
            >
              <button
                type="button"
                :class="`bg-light list-group-item list-group-item-action borderless`"
                @click.shift="selecionarMultiplos(index, dadoAssociado)"
                @click.ctrl="selecionarMultiplos(index, dadoAssociado)"
                @click.exact="selecionarItemAssociado(index)"
              >
                <SGPIconComponent icon="mdi-check" :color="`${item.selecionado ? 'primary' : '#cccccc' }`" />
                {{ item.descricao }}
              </button>
            </div>

          </div>
        </b-col>

        <b-col cols="auto" class="px-1">

          <div class="d-flex flex-column h-100 justify-content-center ">
            <div v-if="exibirBotoesSelecionarTodos">
              <SGPFormBotaoComponent fab @click="transportarTodosAssociados()" small class="ml-6 mb-5">
                <SGPIconComponent icon="mdi-chevron-triple-right" />
              </SGPFormBotaoComponent>
              <SGPFormBotaoComponent fab @click="transportarTodosDisponiveis()" small class="ml-6 mb-5">
                <SGPIconComponent icon="mdi-chevron-triple-left" />
              </SGPFormBotaoComponent>
            </div>
            <div v-else>
              <SGPFormBotaoComponent fab @click="transportarAssociados()" small class="ma-2">
                <SGPIconComponent icon="mdi-chevron-right"></SGPIconComponent>
              </SGPFormBotaoComponent>
  
              <SGPFormBotaoComponent fab @click="transportarDisponiveis()" small class="ma-2">
                <SGPIconComponent icon="mdi-chevron-left"></SGPIconComponent>
              </SGPFormBotaoComponent>
            </div>
          </div>

        </b-col>

        <b-col col lg="4" ref="listaDisponiveis" class="bg-light no-padding">
          <div class="min-height" style="height: 510px !important; overflow-y: auto !important">
            <div class="titulo"><span>{{ tituloDisponiveis }} {{ (!tituloCompleto)?' Disponíveis':''}}</span></div>

            <div
              v-for="(item,index) in dadoDisponivel"
              :key="index"
            >
              <button
                type="button"
                class="bg-light list-group-item list-group-item-action borderless "
                @click.shift="selecionarMultiplos(index, dadoDisponivel)"
                @click.ctrl="selecionarMultiplos(index, dadoDisponivel)"
                @click.exact="selecionarItemDisponivel(index)"
              >
                <SGPIconComponent icon="mdi-check" :color="`${item.selecionado ? 'primary' : '#cccccc' }`" />
                {{ item.descricao }}
              </button>
            </div>
          </div>
        </b-col>

      </b-row>
    </div>

    <b-col col lg="9" style="">
      <div class="text-center">
        <SGPFormBotaoComponent
          type="submit"
          @click="submit()"
        >
          Salvar Associações
        </SGPFormBotaoComponent>
      </div>
    </b-col>

  </div>

</template>

<script>
export default {
  name: 'SGPAssociarComponent',

   props: {

    tituloAssociados: {
      type: String,
      required: false,
      default: '',
    },
    tituloDisponiveis: {
      type: String,
      required: false,
      default: '',
    },
    dadoAssociado: {
      type: Array,
      required: false,
    },
    dadoDisponivel: {
      type: Array,
      required: false,
    },
    multiplo: {
      type: Boolean,
      required: false,
      default: true,
    },
    tituloCompleto: {
      type: Boolean,
      required: false,
      default: false,
    },
    exibirBotoesSelecionarTodos: {
    type: Boolean,
    required: false,
    default: false, 
  }

  },

  data () {
    return {
      intervalo: [],
      alturaLista: 0
    }
  },

  emit: [
    'sgpSalvarAssociacoesEmit'
  ],

  methods:{

    selecionarMultiplos (i, lista) {
      this.intervalo.push(i);
      this.intervalo.sort()

      if( this.intervalo.length === 2 ) {
        lista.forEach(( item, index ) => {
          if(index >= this.intervalo[0] && index <= this.intervalo[1]) {
            item.selecionado = !item.selecionado;
          }
        });
        this.intervalo = [];
      }
    },

    selecionarItemAssociado (index) {
      this.$props.dadoAssociado[index].selecionado = !this.$props.dadoAssociado[index].selecionado
    },

    selecionarItemDisponivel (index) {
      this.$props.dadoDisponivel[index].selecionado = !this.$props.dadoDisponivel[index].selecionado
    },

    transportarAssociados () {
      const listaDelecao = []

      this.$props.dadoAssociado.forEach(item => {
        if (item.selecionado) {
          item.selecionado = false
          this.$props.dadoDisponivel.push({...item})
          listaDelecao.push(item)
        }
      })

      listaDelecao.forEach(item => {
        this.$props.dadoAssociado.splice(this.$props.dadoAssociado.indexOf(item), 1)
      })
    },

    transportarDisponiveis () {
      const listaDelecao = []

       this.$props.dadoDisponivel.forEach(item => {
        if (item.selecionado) {
          item.selecionado = false
          this.$props.dadoAssociado.push({...item})
          listaDelecao.push(item)
        }
      })

      listaDelecao.forEach(item => {
        this.$props.dadoDisponivel.splice(this.$props.dadoDisponivel.indexOf(item), 1)
      })
      
    },

    submit () {
      let listaAssociados = this.dadoAssociado;
      let listaDisponivel = this.dadoDisponivel;
      this.$emit('sgpSalvarAssociacoesEmit', { listaAssociados, listaDisponivel });
    },
    transportarTodosAssociados() {
    this.$props.dadoDisponivel.push(...this.$props.dadoAssociado.map(item => {
      item.selecionado = false; 
      return { ...item }; 
    }));
    this.$props.dadoAssociado.splice(0, this.$props.dadoAssociado.length); 
  },

  transportarTodosDisponiveis() {
    this.$props.dadoAssociado.push(...this.$props.dadoDisponivel.map(item => {
      item.selecionado = false; 
      return { ...item }; 
    }));
    this.$props.dadoDisponivel.splice(0, this.$props.dadoDisponivel.length); 
  },
  },
}
</script>

<style lang="scss" scoped>
  .no-padding {
    padding: 0px;
  }

  .alturaMin {
    min-height: 300px;
  }

  .titulo {
    background-color: #E3262E;
    padding: 3px;
    color: white;
  }

  .borderless {
    border: none;
  }

  .iconHover:hover {
    color: red
  }
</style>
